import { createApp } from '@backstage/frontend-defaults';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import appVisualizerPlugin from '@backstage/plugin-app-visualizer';
import authPlugin from '@backstage/plugin-auth';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import catalogUnprocessedEntitiesPlugin from '@backstage/plugin-catalog-unprocessed-entities/alpha';
import devToolsPlugin from '@backstage/plugin-devtools/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import assistantPlugin, {
  assistantDockModule,
} from '@internal/plugin-assistant/alpha';
import rbacPlugin from '@internal/plugin-rbac/alpha';
import policyPlugin from '@internal/plugin-policy/alpha';
import remoteAccessPlugin from '@internal/plugin-remote-access/alpha';
import stackEntityPlugin from '@internal/plugin-stack-entity/alpha';
import stackGrafanaPlugin from '@internal/plugin-stack-grafana/alpha';
import storageLifecyclePlugin from '@internal/plugin-storage-lifecycle/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { themeModule } from './modules/theme';
import { homeModule } from './modules/home';
import { catalogViewModule } from './modules/catalogview';
import { appVisualizerModule } from './modules/catalogview/visualizer';
import { devToolsModule, unprocessedEntitiesModule } from './modules/devtools';
import { entityModule } from './modules/entity';
import { scaffolderModule } from './modules/scaffolder';
import { stacksModule } from './modules/stacks';
import { serviceAccountsModule } from './modules/serviceaccounts';

export default createApp({
  features: [
    apiDocsPlugin,
    appVisualizerPlugin,
    appVisualizerModule,
    authPlugin,
    authModule,
    catalogPlugin,
    catalogGraphPlugin,
    catalogUnprocessedEntitiesPlugin,
    unprocessedEntitiesModule,
    devToolsPlugin,
    devToolsModule,
    kubernetesPlugin,
    orgPlugin,
    rbacPlugin,
    assistantPlugin,
    assistantDockModule,
    notificationsPlugin,
    scaffolderPlugin,
    searchPlugin,
    techdocsPlugin,
    userSettingsPlugin,
    navModule,
    themeModule,
    homeModule,
    catalogViewModule,
    entityModule,
    scaffolderModule,
    stacksModule,
    serviceAccountsModule,
    remoteAccessPlugin,
    stackEntityPlugin,
    stackGrafanaPlugin,
    storageLifecyclePlugin,
    policyPlugin,
  ],
});
